<footer class="pwa">
  <div class="pwa__list">
  <ng-content></ng-content>
  </div>
</footer>
